import React from "react";
const getFillColor = (color: string) => {
  return color === "currentColor" ? `` : `var(--color-${color})`;
};
const SvgBackIcon = ({ title, theme = null, titleId = "", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 36 36"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M30 16.5H11.74l8.38-8.38L18 6 6 18l12 12 2.12-2.12-8.38-8.38H30v-3z"
      className="back_svg__nc-icon-wrapper"
      fill="currentColor"
    />
  </svg>
);
export interface Props {
  color?: string;
  width?: string;
  height?: string;
  title: string;
  titleId?: string;
  theme?: any;
  fill?: string;
}
const SvgBackStyle = ({
  color = "currentColor",
  title,
  fill,
  ...props
}: Props) => (
  <SvgBackIcon
    color={getFillColor(color)}
    className={color === "currentColor" ? "icon-current-color" : ""}
    {...(color !== "currentColor"
      ? { style: { color: getFillColor(color), fill: getFillColor(color) } }
      : null)}
    fill={fill ?? getFillColor(color)}
    title={title}
    {...props}
  />
);
export const BackIcon: any = SvgBackStyle;
export default BackIcon;
